import React from 'react';
import OfferCard from './OfferCard';
import styled from 'styled-components';

const ProductOfferSection = () => {
  const offers = [
    {
      icon: 'FaTools',
      title: 'Tailored PLM Solutions',
      description: 'Deliver PLM products tailored to meet your business requirements efficiently and effectively.',
    },
    {
      icon: 'FaChartLine',
      title: 'Process Improvement',
      description: 'Enhance processes, productivity, profitability, ROI, and manage product complexity with Lean Methodology.',
    },
    {
      icon: 'FaRoad',
      title: 'PLM Strategy Development',
      description: 'Develop a robust PLM vision, strategy, and long-term roadmap for our clients.',
    },
    {
      icon: 'FaClipboardCheck',
      title: 'License Selection',
      description: 'Assist in selecting the right mix of licenses for Siemens Teamcenter PLM based on current and future business needs.',
    },
    {
      icon: 'FaBullseye',
      title: 'Business-Aligned Implementation',
      description: 'Implement Teamcenter PLM in alignment with true business objectives and ensure a solid PLM vision, strategy, and long-term roadmap.',
    },
    {
      icon: 'FaPlusCircle',
      title: 'Value-Added Services',
      description: 'Guarantee optimal investment in Teamcenter PLM licenses, provide value-added implementation services, and offer a single source for product sales and implementation services.',
    },
  ];

  return (
    <Section>
      <Container>
        <SectionTitle>Our <span>Services</span></SectionTitle>
        <SectionSubtitle>
          We are committed to delivering quality services to our customers. Our services are:
        </SectionSubtitle>
        <OfferCards>
          {offers.map((offer, index) => (
            <OfferCard
              key={index}
              icon={offer.icon}
              title={offer.title}
              description={offer.description}
            />
          ))}
        </OfferCards>
      </Container>
    </Section>
  );
}

export default ProductOfferSection;

const Section = styled.section`
  padding: 60px 20px;
  background-color: #062c3f;
  text-align: center;
`;

const Container = styled.div`
  max-width: 1140px;
  margin: 0 auto;
`;

const SectionTitle = styled.h2`
  font-size: 3.1em;
   font-family: "Poppins", system-ui;
  color: #00cbf1;
  font-weight: 700;
  margin-bottom: 20px;
  text-align: left;
  position: relative;

  span {
    color: #f0faff;
  }

 

  @media (max-width: 768px) {
    font-size: 2.2em;
  }

  @media (max-width: 480px) {
    font-size: 2em;
    text-align: left;
  }
`;

const SectionSubtitle = styled.p`
  font-family: "Poppins", system-ui;
  font-size: 1.2em;
  color: #f0faff;
  line-height: 1.6;
  margin-bottom: 40px;
  text-align: left;
  hyphens: auto;

  @media (max-width: 768px) {
    font-size: 1em;
  }

  @media (max-width: 480px) {
    text-align: left;
    font-size: 0.9em;
  }
`;

const OfferCards = styled.div`
  display: flex;
  justify-content: center;
  gap: 30px;
  flex-wrap: wrap;
`;

